import { Link } from 'react-router-dom';
import { IconPhone } from '../icons/navigationIcons';
import { cn } from '../../lib/utils';
import { MERCHANT_MOBILE_SWITCH_PATH } from '../../utils/accessPolicy';

type MerchantMobilePortalReturnProps = {
  className?: string;
  fixed?: boolean;
};

export default function MerchantMobilePortalReturn({
  className,
  fixed = true,
}: MerchantMobilePortalReturnProps) {
  return (
    <Link
      to={MERCHANT_MOBILE_SWITCH_PATH}
      aria-label="Return to mobile portal"
      title="Return to mobile portal"
      className={cn(
        'inline-flex min-h-12 items-center justify-center gap-2 rounded-full border border-slate-950 bg-slate-950 px-4 py-3 text-base font-semibold text-white shadow-2xl ring-2 ring-white/90 transition hover:bg-slate-800 dark:border-white dark:bg-white dark:text-slate-950 dark:ring-slate-950/40 dark:hover:bg-slate-100',
        fixed
          ? 'fixed bottom-[calc(env(safe-area-inset-bottom)+5.25rem)] left-3 right-3 z-40 sm:left-auto sm:w-80'
          : null,
        className,
      )}
    >
      <IconPhone className="h-4 w-4" strokeWidth={1.8} />
      <span>Mobile portal</span>
    </Link>
  );
}
